module.exports = __webpack_public_path__ + "media/app-store-detail/G2_white-69864391.png";